import CvMakerContext from './app-context';
 
export const t = (key) => CvMakerContext._currentValue.lang[key];

export const lang = {
    farsi: {
        rtl: true,
        ـlangName: 'فارسی',
        file:'فایل',
        print: 'پرینت',
        save: 'ذخیره',
        share: 'اشتراک',
        new: 'جدید',
        setting: 'تنظیمات',
        saveToPc: 'ذخیره در سیستم',
        open: 'باز کردن',
        item: 'افزودن',
        theme: 'قالب',
        login: 'ورود',
        register: 'ثبت نام',
        userName: 'نام کاربری',
        password: 'رمز',
        email: 'ایمیل',
        lang: 'زبان',
        educations: "تحصیلات",
        skills: "مهارتها",
        workExperinces: "تجارب شغلی",
        languages: "زبان",
        freelanceProjects: "پروژه های شخصی",
        certificates: "مدارک و دوره ها",
        education: "تحصیلات",
        skill: "مهارت",
        workExperince: "تجربه شغلی",
        language: "زبان",
        freelanceProject: "پروژه شخصی",
        certificate: "مدرک و دوره",
        summery: 'درباره من',
        smallDesc: 'مختصری درباره من',
        avatar: 'آواتار',
        site: 'وب سایت',
        skillScore: 'نمایش نمره مهارت',
        languageScore: 'نمایش نمره زبان',
        rightToLeftLanguage: 'زبان رزومه راست به چپ است',
        cvSetting: 'تنظیمات رزومه',
        version: 'ورژن',
        color2: 'رنگ',
        github:'گیت هاب',
        linkedin: 'لینکداین',
        marriage: 'وضعیت تاهل',
        militaryService: 'پایان خدمت',
        birthDate: 'متولد',
        if_not_register: 'اگر عضو سایت نیستید',
        if_already_member: 'اگر قبلا عضو شده اید',
        feeBack: 'با نظر خود به ما در هر چه بهتر کردن برنامه کمک کنید',
        fullName:'نام کامل',
        msg: 'نظر/پیشنهاد شما',
        submit: 'ارسال',
        feedBackMnu:'نظر'
    },
    eng: {
        rtl: false,
        ـlangName: 'English',
        file: 'File',
        print: 'Print',
        save: 'Save',
        share:'Share',
        new: 'New',
        setting: 'setting',
        saveToPc: 'save to your Pc',
        open: 'Open',
        item: 'Insert',
        theme: 'theme',
        login: 'Sign in',
        register: 'Sign up',
        userName: 'userName',
        password: 'password',
        email: 'email',
        lang: 'language',
        educations: "Education",
        skills: "Skills",
        workExperinces: "Work Experince",
        languages: "Languages",
        freelanceProjects: "Freelance Projects",
        certificates: "Certificates",
        education: "Education",
        skill: "Skill",
        workExperince: "Work Experince",
        language: "Language",
        freelanceProject: "Freelance Project",
        certificate: "Certificate",
        summery: 'Summery',
        smallDesc: 'Small Desc',
        avatar: 'Avatar',
        site: 'Site',
        skillScore: 'Show Skill Score',
        languageScore: 'Show language Score',
        rightToLeftLanguage: 'Right-To-Left',
        cvSetting: 'CV Setting',
        version: 'Version',
        color2: 'Color',
        github: 'Github',
        linkedin: 'LinkedIn',
        marriage: 'Marriage',
        militaryService: 'Military Service',
        birthDate: 'Birthdate',
        if_not_register: 'if you not member of site',
        if_already_member: 'if you are member',
        feeBack: 'Help us improve the program with your feedback',
        fullName: 'full Name',
        msg: 'your feedback',
        submit: 'submit',
             feedBackMnu: 'feed back'
    },
    jap: {
        rtl: false,
        ـlangName: '日本',
        file: 'ファイル',
        print: '印刷する',
        save: '保存',
        new: '新しい',
        setting: '設定',
        saveToPc: 'PC に保存',
        open: '開ける',
        item: 'アイテム',
        theme: 'テーマ',
        login: 'ログイン',
        register: 'サインアップ',
        userName: 'ユーザー名',
        password: 'パスワード',
        email: 'Eメール',
        lang: '言語',
        educations: "教育",
        skills: "スキル",
        workExperinces: "実務経験",
        languages: "言語",
        freelanceProjects: "フリーランスのプロジェクト",
        certificates: "証明書",
        education: "教育",
        skill: "スキル",
        workExperince: "実務経験",
        language: "言語",
        freelanceProject: "フリーランスプロジェクト",
        certificate: "証明書",
        summery: '夏らしい',
        smallDesc: '小さな説明',
        avatar: 'アバター',
        site: 'サイト',
        skillScore: 'スキルスコアを表示',
        languageScore: '言語スコアを表示',
        rightToLeftLanguage: 'R右から左へ記述する言語',
        cvSetting: 'CV設定',
        version: 'バージョン',
        color2: '色',
        github: 'Github',
        linkedin: 'LinkedIn',
        marriage: '結婚',
        militaryService: 'ミリタリーサービス',
        birthDate: '生年月日',
        if_not_register: 'サイトの会員でない場合',
        if_already_member: 'あなたが会員であれば',
        feeBack: 'フィードバックを活用してプログラムの改善にご協力ください',
        fullName: 'フルネーム',
        msg: 'あなたのフィードバック',
        submit: '送信',
        feedBackMnu: 'フィードバック'
    },
};
